<template>
    <div>
        <div class="row">

            <div :class="{'col-12 col-md-8': showSidebar}" class="col-form">
                <keep-alive>
                    <transition :name="transition" mode="out-in">
                        <component
                            ref="currentStep"
                            :is="currentStep"
                            :direction="direction"
                            @update="proccessStep"
                        >
                        </component>
                    </transition>
                </keep-alive>
            </div>
            <transition name="sideout" mode="out-in">
                <side-bar v-if="showSidebar" />
            </transition>
            
            <form-gravity v-if="showForm" />
                
        </div>
    </div>
</template>

<script>
// steps
import DurationStep from '@/components/step/DurationStep';
import QuantityStep from '@/components/step/QuantityStep';
import ObiettiviStep from '@/components/step/ObiettiviStep';
import AllergeniStep from '@/components/step/AllergeniStep';
import ProductsStep from '@/components/step/ProductsStep';
import BuyStep from '@/components/step/BuyStep';
import ClosedStep from '@/components/step/ClosedStep';

// extra components
import SideBar from '@/components/SideBar';
import FormGravity from '@/components/FormGravity';
// library


export default {
    name: "FormStep",
    data() {
        return {
            transition: "showstep",
            direction: "nextstep",
            canGoNext: false,
            asyncState: null,
            updateStep: false,
            steps: [
                DurationStep,
                QuantityStep,
                ObiettiviStep,
                AllergeniStep,
                ProductsStep,
                BuyStep,
                ClosedStep
            ]
        }
    },
    components: {
        // step
        DurationStep,
        QuantityStep,
        ObiettiviStep,
        AllergeniStep,
        ProductsStep,
        BuyStep,
        // structure component
        SideBar,
        FormGravity,
        // Last step
        ClosedStep
    },
    computed: {
        abbonamento() {
            return this.$store.state.abbonamento
        },
        subscriptions() {
            return this.$store.state.subscriptions           
        },
        length() {
            return this.steps.length;
        },
        lengthStep() {
            return this.steps.length - 1;
        },
        isLastStep() {
            return this.step === this.length;
        },
        currentStep() {
            this.log('currentStep: '+this.step);
            return this.steps[this.step];
        },
        step: {
            get() {
                return this.$store.state.step;
            },
            set(val) {
                this.$store.commit("setStep", val);
            }
        },
        showSidebar() {
            return !['ClosedStep', 'BuyStep'].includes(this.currentStep.name);
        },
        showForm() {
            return ['ProductsStep', 'BuyStep'].includes(this.currentStep.name);
        }
    },
    methods: {
        GTM_Label() {
            if ("string" == typeof this.currentStep)
                return this.currentStep;

            let step = this.$store.getters.step;
            return `Step ${step} - ` + this.steps[step];
        },
        updateAsyncState(state) {
            this.asyncState = state;
        },
        reset() {

        },
        goBack() {
            this.log("Back current step", this.isUpdate, this.step);
            // torna indietro solo se è aggiornamento e step maggiore di obiettivi
            if(!this.isUpdate || (this.isUpdate && this.step > 2)){
                this.direction = "prevstep";
                let step = this.step - 1;
                this.$store.commit("setStep", step);
            }
        },
        goNext() {
            if (this.step < parseInt(this.lengthStep-1) ) {
                this.direction = "nextstep";
                let step = this.step + 1;
                this.log('gonext', step);
                this.$store.commit("setStep", step);
            }
        },
        proccessStep({ next=false, back=false, canGoNext=false}) {
            // { valid,  data, back = false, reset = false, updateStep = false }
            // log('processStep', valid, data, back);
            // GTM evento fine
            // this.GTM_trackEvent(this.GTM_Category, this.GTM_Label + " fine");

            // if (reset) {
            //     this.reset();
            //     return
            // }
            this.canGoNext = canGoNext;

            if (back) {
                this.goBack();
                return
            }
            if (next) {
                this.goNext();
                return
            }
            // this.updateStep = updateStep

            // 

            // this.nextButtonAction();
            


        }
    }
}
</script>

<style lang="scss">
.showstep-enter{
    opacity: 0;
    transform: translateY(20px);
}
.showstep-enter-active {
    transition: all .2s ease-in .2s;
}
.showstep-enter-to{
    opacity: 1;
    transform: translateY(0px);
}
.showstep-leave{
    opacity: 1;
    transform: translateY(0px);
}
.showstep-leave-active {
    transition: all .2s ease-in .2s;
}
.showstep-leave-to{
    opacity: 0;
    transform: translateY(-20px);
}


.sideout-enter{
    opacity: 0;
    transform: translateX(20px);
}
.sideout-enter-active {
    transition: all .2s ease-in 0;
}
.sideout-enter-to{
    opacity: 1;
    transform: translateX(0px);
}
.sideout-leave{
    opacity: 1;
    transform: translateX(0px);
}
.sideout-leave-active {
    transition: all .4s ease-in 0;
}
.sideout-leave-to{
    opacity: 0;
    transform: translateX(20px);
}

.col-form{
    transition: all .2s ease-in .4s;
}

</style>